module.exports = __webpack_public_path__ + "img/app_in_app.ef247263.png";